import { render } from "./FilterSoldtoCustomerCurah.vue?vue&type=template&id=9f5a56d6"
import script from "./FilterSoldtoCustomerCurah.vue?vue&type=script&lang=js"
export * from "./FilterSoldtoCustomerCurah.vue?vue&type=script&lang=js"
script.render = render

export default script